<div class="d-flex justify-content-start align-items-center">
  <div
    class="card p-1"
    style="min-width: 4rem"
    [ngClass]="pastDueSubject.value ? 'alert-warning' : 'alert-info'"
  >
    {{ mBarReading }}
  </div>
  &nbsp;mbar(s)
  <div class="font-italic small mx-2">
    <div *ngIf="logActive === true; else logInactive" class="text-success">
        <ng-container *ngIf="!pastDueSubject.value">
            <i class="fa fa-check mr-1"></i>Logging active
        </ng-container>
    </div>
    <ng-template #logInactive>
        <div *ngIf="logActive===false" class="text-danger">Logging inactive</div>
    </ng-template>
    </div>
    <i role="button" class="fa fa-sync small text-primary" (click)="refresh()"></i>
</div>
